<template>
  <v-dialog v-model="open" max-width="500px" :scrollable="true" @update:model-value="openChange" v-on:keydown.stop.esc="onClose">
    <template v-slot:activator="{ props }">
      <v-list-item v-bind="props">
        <v-list-item-title>Export to Azure DevOps</v-list-item-title>
      </v-list-item>
    </template>
    <template #default>
      <v-card :flat="true">
        <v-toolbar density="compact" color="white">
          <v-toolbar-title>Map your {{ brand.name }} project to an Azure DevOps project</v-toolbar-title>
          <v-btn icon @click="onClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <p class="mb-0">
            If you haven't done it already, please install the {{ brand.integrations.marketplaceAppName }} app from the Visual Studio Marketplace. Then login to {{ brand.name }} from Azure DevOps and map your {{ brand.name }} project to your Azure DevOps project by following the instructions in Azure DevOps.
          </p>
          <p>&nbsp;</p>
          <p><a href="https://marketplace.visualstudio.com/items?itemName=Qlerify.qlerify-for-azure-boards" target="_blank">Link to Visual Studio Marketplace App Here</a></p>
          <p>&nbsp;</p>
        </v-card-text>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import brand from '@/composables/useBrand'

export default {
  data () {
    return {
      open: false
    }
  },

  computed: {
    brand: () => brand
  },

  methods: {
    openChange (open) {
      if (!open) {
        this.onClose()
      }
    },

    onClose () {
      this.open = false
    }
  }
}
</script>
